"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniqueSellingPointQuestionWidget = exports.UniqueSellingPointWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var portal_core_1 = require("@ferry/portal-core");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var UniqueSellingPointWidget = function (_a) {
    var brandName = _a.brandName;
    var displayBrandName = (0, portal_core_1.getPrettifiedInteractionBrandName)(brandName);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "unique-selling-point-widget", children: [(0, jsx_runtime_1.jsxs)("div", { className: "d-flex col", children: [(0, jsx_runtime_1.jsx)("img", { className: "quote-page-icon email m-0", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/phone-crossed.svg"), alt: "email icon" }), (0, jsx_runtime_1.jsx)("p", { className: "my-auto ml-2", children: "Manage your policy yourself online" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex col", children: [(0, jsx_runtime_1.jsx)("img", { className: "quote-page-icon make-claim m-0", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/car-icon-colored.svg"), alt: "car icon" }), (0, jsx_runtime_1.jsxs)("p", { className: "my-auto ml-2", children: [displayBrandName, " Genuine Parts & Approved Repairs"] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex col", children: [(0, jsx_runtime_1.jsx)("img", { className: "quote-page-icon pound-crossed m-0", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/piggybank.svg"), alt: "piggybank icon" }), (0, jsx_runtime_1.jsx)("p", { className: "my-auto ml-2", children: "No admin fees" })] })] }));
};
exports.UniqueSellingPointWidget = UniqueSellingPointWidget;
var UniqueSellingPointQuestionWidget = /** @class */ (function (_super) {
    __extends(UniqueSellingPointQuestionWidget, _super);
    function UniqueSellingPointQuestionWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UniqueSellingPointQuestionWidget.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)(exports.UniqueSellingPointWidget, { brandName: this.props.interaction.brandName });
    };
    return UniqueSellingPointQuestionWidget;
}(plugin_journey_1.WidgetBase));
exports.UniqueSellingPointQuestionWidget = UniqueSellingPointQuestionWidget;
//# sourceMappingURL=UniqueSellingPointWidget.js.map